var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#1677ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5845 6.2934C9.80995 6.78394 11.3951 9.16835 13.0181 9.95414C13.7676 10.317 14.6309 10.6139 14.9367 10.6139C15.5879 10.6139 15.6701 9.57312 15.1393 8.0507C14.6009 6.50617 11.8962 5.46241 10.5845 6.2934ZM10.5997 10.6363C8.17439 11.1549 6.67142 13.7063 7.06135 16.6439C7.48855 19.8662 8.80447 21.8858 11.3687 23.2545C13.2391 24.253 17.0915 24.2474 18.9874 23.2439C22.2998 21.4899 24.2646 16.8781 23.0585 13.6868C22.0794 11.0949 19.8184 10.0412 16.9734 10.8504C15.3656 11.308 14.9681 11.3116 13.4305 10.8834C12.3728 10.5892 11.2707 10.4928 10.5997 10.6363ZM11.5336 13.4064C11.5336 14.309 10.5588 15.0139 9.74299 14.7009C8.59037 14.2585 9.40552 12.5932 10.7749 12.5932C11.3614 12.5932 11.5336 12.778 11.5336 13.4064Z",
    fill: "#1677ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/Vegan.2b26f2b0a0c5b241cac784ddae372d01.svg";
export { ForwardRef as ReactComponent };